import { IAuthorizationRequirement } from '../authorizationrequirement';

export class AuthorizationPolicy {
  requirements: IAuthorizationRequirement[] = [];

  constructor(requirements: IAuthorizationRequirement[]) {
    this.requirements.push(...requirements);
  }
}
